<template>
  <div>
    <b-nav-item-dropdown
        id="dropdown-grouped"
        variant="link"
        class="dropdown-language"
        right
    >
      <template #button-content>
        <b-img
            :src="currentLocale.img"
            height="14px"
            width="22px"
            :alt="currentLocale.locale"
        />
        <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
      </template>
      <b-dropdown-item
          v-for="localeObj in locales"
          :key="localeObj.locale"
          @click="isRTLChange(localeObj.dir); $i18n.locale = localeObj.locale"
      >
        <b-img
            :src="localeObj.img"
            height="14px"
            width="22px"
            :alt="localeObj.locale"
        />
        <span class="ml-50"> {{ $t(localeObj.name) }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>

</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import store from '@/store'
import useBookmark_lang_skin from './useBookmark_lang_skin'
import { onBeforeMount } from '@vue/composition-api'
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
     // return this.locales.find(l => l.locale === 'en')
   if( store.state==undefined ||  store.state.auth.userData==null){return 'ar'}
   
   const lang=   store.state.auth.userData.settings.lang==undefined?'ar': store.state.auth.userData.settings.lang;
   return  this.locales.find(l => l.locale === lang) ;

    },
  },

  props: {
    spinner: {
      type: Boolean,
      default: () => false
    }
  },
  setup(props, {root, emit}) {


    // console.log('local', this.$i18n.locale)

    onBeforeMount(() => {

    })

    const locales = [
      {
        dir: 'ltr',
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      {
        dir: 'rtl',
        locale: 'ar',
        img: require('@/assets/images/flags/sa.png'),
        name: 'Arabic',
      },
    ]

    const { langToggle } = useBookmark_lang_skin()

    const isRTLChange = (dir) => {
     ///here change flang
      emit('update:spinner', true)
      store.commit('appConfig/TOGGLE_RTL', dir)
      store.commit('auth/SET_LANG', dir=='ltr'?'en':'ar')
      langToggle(dir === 'rtl' ? 'ar' : 'en', () =>
          emit('update:spinner', false))
    }


    return {
      locales,
      isRTLChange
    }
  },
}
</script>

<style>

</style>
